import { Card, Empty, Skeleton, Typography } from "@douyinfe/semi-ui";
import { VChart } from "@visactor/react-vchart";
import { DashboardFilters, HomeDashboardApi } from "../api/homeDashboard";
import { useDashboardModule } from "../hooks/useDashboardModule";
import { chartBoxStyle, chartTitleStyle, kpiBoxStyle, kpiItemStyle, STAR_COLOR_MAP } from "../styles";
import { DrawerMode } from "./DetailDrawer";

interface Props {
  filters: DashboardFilters;
  isAdmin: boolean;
  currentTeamId?: number;
  openDrawer: (title: string, params: Record<string, any>, mode?: DrawerMode) => void;
}

export default function VisitStarCard({ filters, openDrawer }: Props) {
  const dist = useDashboardModule(
    () => HomeDashboardApi.getVisitStarDist(filters),
    [filters.startDate, filters.endDate, filters.teamId, JSON.stringify(filters.saleIds)],
    !!filters.startDate
  );
  const trend = useDashboardModule(
    () => HomeDashboardApi.getVisitDailyTrend(filters),
    [filters.startDate, filters.endDate, filters.teamId, JSON.stringify(filters.saleIds)],
    !!filters.startDate && trendDays(filters) > 3
  );

  const showTrend = trendDays(filters) > 3;

  return (
    <Card>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <div style={chartBoxStyle}>
          <Typography.Text style={chartTitleStyle}>上门星级占比</Typography.Text>
          {dist.loading && <Skeleton.Title />}
          {dist.data && dist.data.starDist.length > 0 ? (
            <VChart spec={{
              type: "pie",
              data: [{ values: dist.data.starDist.map(s => ({ name: s.label, value: s.count, key: s.key })) }],
              valueField: "value", categoryField: "name",
              color: { specified: Object.fromEntries(
                dist.data.starDist.map(s => [s.label, STAR_COLOR_MAP[String(s.key)] || "#0093FF"])
              ) },
              label: { visible: true, position: "outside", text: "{name}: {value}" },
              legends: [{ visible: true, position: "right" }],
            } as any} style={{ height: 240 }}
              onClick={(e: any) => {
                const name = e?.datum?.["name"];
                const item = dist.data!.starDist.find(s => s.label === name);
                if (item) openDrawer(`上门 - ${item.label}`, { ...filters, star: item.key }, "visit");
              }} />
          ) : !dist.loading ? <Empty title="暂无上门数据" /> : null}
        </div>
        <div style={chartBoxStyle}>
          <Typography.Text style={chartTitleStyle}>总览</Typography.Text>
          {dist.loading && <Skeleton.Title />}
          {dist.data ? (
            <div style={kpiBoxStyle}>
              <div style={kpiItemStyle}>
                <div style={{ fontSize: 12, color: "var(--semi-color-text-2)" }}>上门客户</div>
                <div style={{ fontSize: 18, fontWeight: 600 }}>{dist.data.total}</div>
              </div>
              <div style={kpiItemStyle}>
                <div style={{ fontSize: 12, color: "var(--semi-color-text-2)" }}>平均星级</div>
                <div style={{ fontSize: 18, fontWeight: 600 }}>{dist.data.avgStar.toFixed(1)}</div>
              </div>
            </div>
          ) : !dist.loading ? <Empty title="暂无数据" /> : null}
        </div>
      </div>
      {showTrend && (
        <div style={{ ...chartBoxStyle, flex: "1 1 100%", marginTop: 8 }}>
          <Typography.Text style={chartTitleStyle}>每日星级趋势</Typography.Text>
          {trend.loading && <Skeleton.Title />}
          {trend.data && trend.data.length > 0 ? (
            <VChart spec={{
              type: "area", data: [{ values: trend.data }],
              xField: "date", yField: "newAssigned",
              area: { style: { fillOpacity: 0.25 } },
              line: { style: { lineWidth: 2 } },
              label: { visible: true, position: "top", text: "{newAssigned}", overlap: false },
            } as any} style={{ height: 180 }}
              onClick={(e: any) => {
                const date = e?.datum?.["date"];
                if (date) openDrawer(`上门 - ${date}`, { ...filters, day: date }, "visit");
              }} />
          ) : !trend.loading ? <Empty title="暂无趋势数据" /> : null}
        </div>
      )}
    </Card>
  );
}

function trendDays(f: DashboardFilters): number {
  try {
    const ms = new Date(f.endDate).getTime() - new Date(f.startDate).getTime();
    return Math.ceil(ms / 86400000) + 1;
  } catch {
    return 0;
  }
}
